import { RootState } from "@/store/store";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const GuestGuard = () => {
    const { isLoggedIn, firstRoute } = useSelector((state: RootState) => state.auth);

    if (isLoggedIn && firstRoute) {
        return <Navigate to={firstRoute || ""} replace />;
    }

    return <Outlet />;
};

export default GuestGuard; 